import React from 'react';

import DeskNav from '../layouts/DeskNav';

import '../../styles/skills.scss'; 
import AlexCloud from '../../images/alexnube.gif';

export default (props) => {
	return (
		<main className='skills'>
			<DeskNav />
			<section className='gif-section'>
				<img className='cloud-gif' src={AlexCloud} alt='cloud' />
			</section>
			<section className='skills-section'>
				<h2>{props.skills.title} </h2>

				<ul>
					{props.skills.tech.map((elem,index) => <li key={index}> {elem} </li>)}
				</ul>
			</section>

		</main>

	);
}